import { render, staticRenderFns } from "./RequestsIndex.vue?vue&type=template&id=a5aa3478&scoped=true"
import script from "./RequestsIndex.vue?vue&type=script&lang=js"
export * from "./RequestsIndex.vue?vue&type=script&lang=js"
import style0 from "./RequestsIndex.vue?vue&type=style&index=0&id=a5aa3478&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5aa3478",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5aa3478')) {
      api.createRecord('a5aa3478', component.options)
    } else {
      api.reload('a5aa3478', component.options)
    }
    module.hot.accept("./RequestsIndex.vue?vue&type=template&id=a5aa3478&scoped=true", function () {
      api.rerender('a5aa3478', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/privacy/RequestsIndex.vue"
export default component.exports